import React, { useEffect, useState } from 'react'
import AdminDashboardLayout from './AdminDashboardLayout'
import { useDispatch, useSelector } from 'react-redux'
import { getProfessionalsAPI, UpdateProfessionalStatusAPI } from '../../redux/slices/superAdminProfessionalSlice'
import { errorHandler } from '../../constants/base'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'

const SuperAdminProfessional = () => {

    const dispatch = useDispatch();
    const loading = useSelector(state => state.superAdminProfessionalSlice.loading);
    const professionals = useSelector(state => state.superAdminProfessionalSlice.professionals);
    const pagination = useSelector(state => state.superAdminProfessionalSlice.pagination);
    const [currentPage, setCurrentPage] = useState(pagination.current_page);

    const [searchBox, setSearchBox] = useState("")

    const fetchProfessionals = async () => {
        const payload = {
            page: currentPage,
            search: searchBox
        }
        await dispatch(getProfessionalsAPI(payload));
    }

    useEffect(() => {
        fetchProfessionals();
    }, [currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    // UPDATE STATUS
    const handleChangeStatus = async (id, newStatus) => {
        const statusUpdate = {
            id: id,
            status: newStatus,
        }

        const res = await dispatch(UpdateProfessionalStatusAPI(statusUpdate))

        if (res.type === 'UpdateProfessionalStatusAPI/fulfilled') {
            if (res.payload.success || res.payload.status || res.payload.data.status === 200) {
                fetchProfessionals(currentPage);
                toast.success("Professional status updated successfully!");
            } else {
                errorHandler(res.payload.errors);
            }
        } else if (res.type === 'UpdateProfessionalStatusAPI/rejected') {
            errorHandler(res.payload.errors);
        } else {
            toast.error('Sorry, something went wrong!');
        }
    };

    // SEARCH BOX HERE
    // const handleSearchBox = async (e) => {
    //     setSearchBox(e.target.value)
    //     console.log(searchBox);
    //     const payload = {
    //         page: currentPage,
    //         search: searchBox
    //     }
    //     const res = await dispatch(getProfessionalsAPI(payload));
    //     console.log(res, "res here");
    // }

    const handleSearchBox = async (e) => {
        const currentSearch = e.target.value;
        setSearchBox(currentSearch);

        console.log(currentSearch);

        const payload = {
            page: currentPage,
            search: currentSearch
        };

        const res = await dispatch(getProfessionalsAPI(payload));
        console.log(res, "res here");
    };
    // SEARCH BOX HERE

    return (
        <>
            <AdminDashboardLayout>
                <div className="search-box-here-main">
                    <h2><i className='fa-solid fa-user-tie'></i> Professionals</h2>

                    <form className="d-flex search-form-box" role="search">
                        <input onKeyUp={handleSearchBox} className="form-control me-2 search-box-main" type="text" placeholder="Search" />
                        <i className="fa-solid fa-magnifying-glass"></i>
                    </form>
                </div>

                {loading ? <div className="loading-center-on-page">
                    <i
                        style={{ fontSize: "52px" }}
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                </div> : <div>
                    {professionals?.length > 0 ? <table className="table superadmin-table-box">
                        <thead>
                            <tr>
                                <th scope="col" className="text-center">#</th>
                                <th scope="col">Full Name</th>
                                <th scope="col">Email</th>
                                <th scope="col" className="text-center">Social Security Number</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {professionals?.map((professional, index) => {
                                return (
                                    <tr key={index}>
                                        <th scope="row" className="text-center">{index + 1}</th>
                                        <td>{professional?.name}</td>
                                        <td>{professional?.email}</td>
                                        <td className="text-center">{professional?.ss_number}</td>
                                        <td className="text-center">
                                            <select
                                                name="status"
                                                id="status"
                                                value={professional?.status}
                                                onChange={(e) => handleChangeStatus(professional.id, e.target.value)}
                                                className="dashboard-select"
                                            >
                                                <option value="Pending">Pending</option>
                                                <option value="Active">Active</option>
                                                <option value="Block">Block</option>
                                            </select>
                                        </td>
                                        <td className="text-center">
                                            <div className="actions-box">
                                                <Link to={`/admin/professional/view/${professional?.id}`}>
                                                    <i className="fas fa-eye"></i>
                                                </Link>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table> : <div className="no-data-found-box d-flex mt-5 justify-content-center col-md-12">
                        <img src="/images/No-data-cuate.png" className='w-50' alt="No Data Found" />
                    </div>}

                    {/* Pagination */}
                    <div className="pagination">
                        {pagination.current_page > 1 && (
                            <button onClick={() => handlePageChange(pagination.current_page - 1)}>&laquo; Previous</button>
                        )}

                        {[...Array(pagination.total_pages)].map((_, i) => (
                            pagination.total_pages >= 2 ?
                                <button
                                    key={i + 1}
                                    className={i + 1 === pagination.current_page ? 'active' : ''}
                                    onClick={() => handlePageChange(i + 1)}
                                >
                                    {i + 1}
                                </button> : ""
                        ))}

                        {pagination.current_page < pagination.total_pages && (
                            <button onClick={() => handlePageChange(pagination.current_page + 1)}>Next &raquo;</button>
                        )}
                    </div>
                </div>}
            </AdminDashboardLayout>
        </>
    )
}

export default SuperAdminProfessional